import { getApiUrl } from "../../services/apiConfig.js";
import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { createDefaultConteudosData } from "../../data/index.js";
import { api } from "../../services/api.js";
import { getSnapshotFromResponse } from "../../services/conteudosApi.js";
import { VestibularesPage } from "../StudentPanel/Vestibulares/index.jsx";
import { SimuladoresConteudoStudentPage } from "../StudentPanel/SimuladoresConteudo/index.jsx";
import { OlimpiadaConteudoStudentPage } from "../StudentPanel/OlimpiadaConteudo/index.jsx";
import { ConteudosStudentPage } from "../StudentPanel/Conteudos/index.jsx";
import { AdminAlunos } from "../AdminPanel/pages/Alunos/index.jsx";
import { getTaskBonusPeriod } from "../../hooks/useTaskBonusTotals.js";
import { AdminCardapio } from "../AdminPanel/pages/Cardapio/index.jsx";
import { AdminMeritos } from "../AdminPanel/pages/Meritos/index.jsx";
import { AdminDesafios } from "../AdminPanel/pages/Desafios/index.jsx";
import { AdminAgendamentos } from "../AdminPanel/pages/Agendamentos/index.jsx";
import { Feed } from "../StudentPanel/Feed/index.jsx";
import { AdminQuestoes } from "../AdminPanel/pages/Questoes/index.jsx";
import { Rankings } from "../StudentPanel/Rankings/index.jsx";
import * as ReactDOM from "react-dom/client";
function InstitutionLibraryView(value) {
  const [snapshot, setSnapshot] = useState(createDefaultConteudosData());
  const [loading, setLoading] = useState(value.type !== "vestibulares");
  const [error, setError] = useState("");
  const [target, setTarget] = useState(null);
  useEffect(() => {
    if (value.type === "vestibulares") return;
    let alive = true;
    const abort = new AbortController();
    setLoading(true);
    const path = {
      reforco: "/conteudos/aluno",
      simuladores: "/simuladores-conteudo/aluno",
      olimpiadas: "/olimpiada-conteudo/aluno",
    }[value.type];
    api
      .get(path, {
        signal: abort.signal,
      })
      .then((response) => {
        if (alive) setSnapshot(getSnapshotFromResponse(response).snapshot);
      })
      .catch((err) => {
        if (alive && !abort.signal.aborted)
          setError(
            "Não foi possível abrir os materiais. Volte à visão geral e tente novamente.",
          );
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
      abort.abort();
    };
  }, [value.type]);
  if (value.type === "vestibulares")
    return <VestibularesPage currentStudent={null} />;
  if (loading)
    return (
      <p className={"dp-library-loading"} role={"status"}>
        {"Carregando materiais…"}
      </p>
    );
  if (error)
    return (
      <p className={"dp-library-error"} role={"alert"}>
        {error}
      </p>
    );
  const shared = {
    currentStudent: null,
    showFlash: value.notify,
    onSelectLesson: value.onSelectLesson,
    libraryType: value.type,
  };
  if (value.type === "simuladores")
    return (
      <SimuladoresConteudoStudentPage
        {...shared}
        simuladoresConteudo={snapshot}
        setSimuladoresConteudo={setSnapshot}
        simuladoresConteudoNavigationTarget={target}
        setSimuladoresConteudoNavigationTarget={setTarget}
      />
    );
  if (value.type === "olimpiadas")
    return (
      <OlimpiadaConteudoStudentPage
        {...shared}
        olimpiadaConteudo={snapshot}
        setOlimpiadaConteudo={setSnapshot}
        olimpiadaConteudoNavigationTarget={target}
        setOlimpiadaConteudoNavigationTarget={setTarget}
      />
    );
  return (
    <ConteudosStudentPage
      {...shared}
      conteudos={snapshot}
      setConteudos={setSnapshot}
      conteudosNavigationTarget={target}
      setConteudosNavigationTarget={setTarget}
    />
  );
}
/* Included inside the existing React bundle by the guarded builder.
   jr is the original student list; wr remains its original editing form. */
function InstitutionStudentsPage(props) {
  const [students, setStudents] = useState([]);
  const [editingStudent, setEditingStudent] = useState(null);
  const [meta, setMeta] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let alive = true;
    props
      .loadMeta()
      .then((data) => {
        if (alive) setMeta(data);
      })
      .catch((err) => {
        if (alive && err.name !== "AbortError") setError(err.message);
      });
    return () => {
      alive = false;
    };
  }, [props.loadMeta]);
  if (error)
    return (
      <div className={"fl2 er"} role={"alert"}>
        {error}
      </div>
    );
  if (!meta) return <p role={"status"}>{"Carregando alunos…"}</p>;
  return (
    <AdminAlunos
      students={students}
      setStudents={setStudents}
      editingStudent={editingStudent}
      setEditingStudent={setEditingStudent}
      houses={meta.houses}
      teachers={[]}
      gruposAcesso={meta.gruposAcesso}
      checkpoints={[]}
      setCheckpoints={() => {}}
      showFlash={props.notify}
      institutionContext={props.context}
    />
  );
}
/* Runs inside the existing React bundle. Reuses Lr/yr/br/Ir/er; scoped requests never use global administration endpoints. */
function InstitutionNativePage({ screen, context, notify, onStudent }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [query, setQuery] = useState(
    screen === "rankings" ? getTaskBonusPeriod("semana") : {},
  );
  const revision = useRef(0);
  const [refresh, setRefresh] = useState(0);
  const reload = useCallback(() => setRefresh((value) => value + 1), []);
  useEffect(() => {
    const generation = ++revision.current;
    const abort = new AbortController();
    context
      .request(
        "native-screen",
        {
          screen,
          ...query,
        },
        "GET",
        undefined,
        abort.signal,
      )
      .then((result) => {
        if (generation === revision.current && !abort.signal.aborted) {
          setData(result);
          setError("");
        }
      })
      .catch((err) => {
        if (!abort.signal.aborted && generation === revision.current) {
          setData(null);
          setError(err.message);
        }
      });
    return () => abort.abort();
  }, [screen, context, query, refresh]);
  useEffect(() => {
    if (screen !== "rankings") return;
    const visibleReload = () => { if (!document.hidden) reload(); };
    const timer = window.setInterval(visibleReload, 30000);
    window.addEventListener("focus", visibleReload);
    window.addEventListener("dm-learning-changed", visibleReload);
    document.addEventListener("visibilitychange", visibleReload);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener("focus", visibleReload);
      window.removeEventListener("dm-learning-changed", visibleReload);
      document.removeEventListener("visibilitychange", visibleReload);
    };
  }, [screen, reload]);
  const onRange = useCallback(
    (period) =>
      setQuery((old) =>
        JSON.stringify(old) === JSON.stringify(getTaskBonusPeriod(period))
          ? old
          : getTaskBonusPeriod(period),
      ),
    [],
  );
  const onDay = useCallback(
    (day) =>
      setQuery((old) =>
        old.day === day
          ? old
          : {
              ...old,
              day,
            },
      ),
    [],
  );
  const mountedContext = useMemo(
    () => ({
      ...context,
      readOnly: screen === "meritos",
      catalog: screen === "loja" ? "loja" : "cardapio",
      onRange,
      onDay,
      reload,
      onSearch: (text) =>
        setQuery((old) => ({
          ...old,
          q: text,
          page: 1,
        })),
    }),
    [context, screen, onRange, onDay, reload],
  );
  if (error)
    return (
      <div role={"alert"} className={"fl2 er"}>
        {error}
        <button className={"btn bg bs"} onClick={reload}>
          {"Tentar novamente"}
        </button>
      </div>
    );
  if (!data) return <p role={"status"}>{"Carregando…"}</p>;
  const setter = (key) => (value) =>
    setData((previous) => ({
      ...previous,
      [key]: typeof value === "function" ? value(previous[key] || []) : value,
    }));
  const common = {
    ...data,
    showFlash: (...args) => {
      notify(...args);
      if (["feed", "questoes"].includes(screen)) reload();
    },
    institutionContext: mountedContext,
  };
  let content;
  if (screen === "cardapio" || screen === "loja") {
    if (screen === "loja")
      common.cardapio = (data.cardapio || []).map((item) => ({
        ...item,
        foto: item.imagem,
        categoria: "salgado",
        preco: null,
      }));
    content = <AdminCardapio {...common} setCardapio={setter("cardapio")} />;
  } else if (screen === "meritos")
    content = <AdminMeritos {...common} setMeritos={setter("meritos")} />;
  else if (screen === "desafios")
    content = <AdminDesafios {...common} setBatalhas={setter("batalhas")} />;
  else if (screen === "agendar")
    content = (
      <AdminAgendamentos
        {...common}
        setSalas={setter("salas")}
        setBloqueios={setter("bloqueios")}
        setAgendamentos={setter("agendamentos")}
      />
    );
  else if (screen === "feed")
    content = (
      <Feed
        {...common}
        adminLogged={true}
        currentStudent={null}
        setCheckpoints={setter("checkpoints")}
        verPerfil={(value) => onStudent?.(value)}
      />
    );
  else if (screen === "questoes")
    content = (
      <AdminQuestoes {...common} setCheckpoints={setter("checkpoints")} />
    );
  else if (screen === "rankings")
    content = (
      <Rankings {...common} verPerfil={(value) => onStudent?.(value)} />
    );
  const pagination = data.pagination;
  return (
    <div className={"r dm-native-screen dm-native-" + screen}>
      {content}
      {pagination && pagination.totalPages > 1 ? (
        <div className={"dm-native-pagination"}>
          <button
            className={"btn bg bs"}
            disabled={pagination.page <= 1}
            onClick={() =>
              setQuery((value) => ({
                ...value,
                page: pagination.page - 1,
              }))
            }
          >
            {"Anterior"}
          </button>
          <span>
            {"Página " + pagination.page + " de " + pagination.totalPages}
          </span>
          <button
            className={"btn bg bs"}
            disabled={pagination.page >= pagination.totalPages}
            onClick={() =>
              setQuery((value) => ({
                ...value,
                page: pagination.page + 1,
              }))
            }
          >
            {"Próxima"}
          </button>
        </div>
      ) : null}
    </div>
  );
}
window.DMInstitutionLibrary = Object.freeze({
  mount: (
    element,
    type,
    notify,
    session = {},
    institutionId = 0,
    options = {},
  ) => {
    const abort = new AbortController();
    const data = session.data || {};
    const auth = {};
    if (session.tipo === "admin") {
      if (data.token) auth["X-Admin-Token"] = data.token;
      if (data.learning_admin_token)
        auth["X-Learning-Token"] = data.learning_admin_token;
    } else auth.Authorization = "Bearer " + (data.access_token || "");
    const interceptor = api.interceptors.request.use((config) => {
      const path = config.url || "";
      if (
        (config.method || "get").toLowerCase() === "get" &&
        (path === "/vestibulares" ||
          /^\/(conteudos|simuladores-conteudo|olimpiada-conteudo)\/(aluno|curso-estrutura|curso-detalhes|aula-detalhes|pesquisa)$/.test(
            path,
          ))
      ) {
        const params = config.params || {};
        config.url = "/school.php";
        config.params = {
          ...params,
          action: "library",
          institution_id: institutionId,
          path,
          content_id: params.id,
        };
        delete config.params.id;
        config.headers = {
          ...config.headers,
          ...auth,
        };
        config.signal =
          config.signal && AbortSignal.any
            ? AbortSignal.any([abort.signal, config.signal])
            : abort.signal;
      }
      return config;
    });
    const view = ReactDOM.createRoot(element);
    view.render(
      <InstitutionLibraryView
        type={type}
        notify={notify}
        onSelectLesson={
          typeof options.onSelectLesson === "function"
            ? options.onSelectLesson
            : null
        }
      />,
    );
    return () => {
      abort.abort();
      api.interceptors.request.eject(interceptor);
      view.unmount();
    };
  },
});
/* Included inside the existing React bundle by the guarded builder.
   jr is the original student list; wr remains its original editing form. */

window.DMInstitutionStudents = Object.freeze({
  mount(element, session, institutionId, options = {}) {
    const role = session?.tipo;
    if (
      !["instituicao", "admin"].includes(role) ||
      !Number.isInteger(Number(institutionId)) ||
      Number(institutionId) < 1
    ) {
      element.textContent = "A gestão de alunos é da instituição.";
      return () => element.replaceChildren();
    }
    const abort = new AbortController();
    const context = Object.freeze({
      institutionId: Number(institutionId),
      key: "dm-students-" + Math.random().toString(36).slice(2),
      onStudentRecord:
        typeof options.onStudentRecord === "function"
          ? options.onStudentRecord
          : null,
    });
    const data = session.data || {};
    const auth = {};
    const notify = options.notify || (() => {});
    if (role === "admin") {
      if (data.token) auth["X-Admin-Token"] = data.token;
      if (data.learning_admin_token)
        auth["X-Learning-Token"] = data.learning_admin_token;
    } else auth.Authorization = "Bearer " + (data.access_token || "");
    const requestId = api.interceptors.request.use((config) => {
      if (config.dmInstitutionContext !== context.key) return config;
      const url = new URL(config.url, window.location.origin);
      const method = (config.method || "get").toLowerCase();
      if (
        url.pathname !== "/students" ||
        !["get", "post", "put"].includes(method)
      ) {
        throw Error("Esta operação não está disponível na instituição.");
      }
      const params = {
        ...Object.fromEntries(url.searchParams),
        ...(config.params || {}),
      };
      const studentId = params.id;
      delete params.id;
      delete params.all;
      const resource = studentId ? "student" : "students";
      config.url = "/institutions.php";
      config.params = {
        ...params,
        resource,
        id: context.institutionId,
      };
      if (studentId) config.params.student_id = studentId;
      config.dmInstitutionList = method === "get" && resource === "students";
      config.headers = {
        ...config.headers,
        ...auth,
      };
      config.signal =
        config.signal && AbortSignal.any
          ? AbortSignal.any([abort.signal, config.signal])
          : abort.signal;
      return config;
    });
    const responseId = api.interceptors.response.use(
      (response) => {
        if (
          response.config.dmInstitutionContext === context.key &&
          response.config.dmInstitutionList
        ) {
          const result = response.data?.data;
          if (!Array.isArray(result?.items) || !result.pagination)
            throw Error("Não foi possível carregar a lista de alunos.");
          response.data = {
            ...response.data,
            data: result.items,
            pagination: result.pagination,
          };
        }
        return response;
      },
      (error) => {
        if (
          error.config?.dmInstitutionContext === context.key &&
          !abort.signal.aborted
        ) {
          notify(
            error.response?.data?.message ||
              "Não foi possível concluir a operação.",
          );
        }
        return Promise.reject(error);
      },
    );
    const loadMeta = async () => {
      const response = await fetch(
        getApiUrl(
          "/api/institutions.php?" +
            new URLSearchParams({
              resource: "student-form-meta",
              id: context.institutionId,
            }),
        ),
        {
          headers: auth,
          signal: abort.signal,
          credentials: "same-origin",
          cache: "no-store",
        },
      );
      const body = await response.json();
      if (!response.ok || body.status !== "success")
        throw Error(body.message || "Não foi possível abrir os alunos.");
      return body.data;
    };
    const view = ReactDOM.createRoot(element);
    view.render(
      <InstitutionStudentsPage
        context={context}
        loadMeta={loadMeta}
        notify={notify}
      />,
    );
    return () => {
      abort.abort();
      api.interceptors.request.eject(requestId);
      api.interceptors.response.eject(responseId);
      view.unmount();
    };
  },
});

/* Runs inside the existing React bundle. Reuses Lr/yr/br/Ir/er; scoped requests never use global administration endpoints. */

window.DMInstitutionNative = Object.freeze({
  mount(element, session, house, screen, options = {}) {
    if (
      !["admin", "instituicao"].includes(session?.tipo) ||
      !Number.isInteger(Number(house)) ||
      Number(house) < 1
    ) {
      element.textContent = "Entre novamente na instituição.";
      return () => element.replaceChildren();
    }
    const abort = new AbortController();
    const data = session.data || {};
    const headers = {};
    if (session.tipo === "admin") {
      if (data.token) headers["X-Admin-Token"] = data.token;
      if (data.learning_admin_token)
        headers["X-Learning-Token"] = data.learning_admin_token;
    } else headers.Authorization = "Bearer " + (data.access_token || "");
    const storedPhotos = new Map();
    async function request(
      resource,
      params = {},
      method = "GET",
      body,
      signal,
    ) {
      if (abort.signal.aborted)
        throw new DOMException("Tela fechada.", "AbortError");
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 15000);
      const listeners = [];
      for (const parent of [abort.signal, signal].filter(Boolean)) {
        const cancel = () => controller.abort();
        parent.addEventListener("abort", cancel, {
          once: true,
        });
        listeners.push([parent, cancel]);
        if (parent.aborted) controller.abort();
      }
      try {
        const paramsAtual2 = new URLSearchParams({
          resource,
          id: house,
          ...Object.fromEntries(
            Object.entries(params).filter(
              ([, item]) => item !== null && item !== undefined,
            ),
          ),
        });
        const res = await fetch(
          getApiUrl("/api/institution-management.php?" + paramsAtual2),
          {
            method,
            headers: {
              ...headers,
              ...(body
                ? {
                    "Content-Type": "application/json",
                  }
                : {}),
            },
            body: body ? JSON.stringify(body) : undefined,
            signal: controller.signal,
            credentials: "same-origin",
            cache: "no-store",
          },
        );
        const json = await res.json();
        if (!res.ok || json.status !== "success") {
          const err = Error(
            json.message || "Não foi possível concluir a operação.",
          );
          err.response = {
            status: res.status,
            data: json,
          };
          throw err;
        }
        if (resource === "native-screen" && Array.isArray(json.data?.cardapio))
          for (const row of json.data.cardapio)
            storedPhotos.set(
              (params.screen === "loja" ? "loja" : "cardapio") + ":" + row.id,
              params.screen === "loja" ? row.imagem : row.foto,
            );
        return json.data;
      } finally {
        clearTimeout(timer);
        for (const [parent, cancel] of listeners)
          parent.removeEventListener("abort", cancel);
      }
    }
    const normalize = (row) => {
      if (!row || typeof row !== "object") return row;
      const out = {
        ...row,
      };
      for (const optionalValue of [
        "id",
        "sala_id",
        "aluno_id",
        "desafiante_id",
        "desafiado_id",
        "vencedor_id",
        "perdedor_id",
        "criado_em",
        "capacidade",
        "dia_semana",
      ])
        if (out[optionalValue] !== null && out[optionalValue] !== undefined)
          out[optionalValue] = Number(out[optionalValue]);
      if ("ativo" in out) out.ativo = Boolean(Number(out.ativo));
      return out;
    };
    async function nativeRequest(method, path, payload) {
      if (["feed", "questoes"].includes(screen)) {
        const communityURL = new URL(path, "https://local.invalid");
        if (
          method === "get" &&
          screen === "feed" &&
          communityURL.pathname === "/students"
        ) {
          const result = await request("native-screen", {
            screen,
            students_only: "1",
            q: payload?.params?.q || "",
            limit: payload?.params?.limit || 6,
          });
          return {
            data: {
              status: "success",
              data: result.students,
            },
          };
        }
        const actions = {
          "/checkpoints/aprovar-questionamento": "approve",
          "/checkpoints/reduzir-questionamento": "reduce",
          "/checkpoints/invalidar-questionamento": "invalidate",
        };
        let body;
        if (
          screen === "feed" &&
          method === "delete" &&
          communityURL.pathname === "/checkpoints"
        )
          body = {
            screen,
            action: "hide",
            checkpoint_id: communityURL.searchParams.get("id"),
          };
        else if (
          screen === "questoes" &&
          method === "post" &&
          actions[communityURL.pathname]
        )
          body = {
            ...payload,
            screen,
            action: actions[communityURL.pathname],
          };
        else throw Error("Esta operação não está disponível nesta tela.");
        const result = await request("community", {}, "POST", body);
        return {
          data: {
            status: "success",
            data: result,
          },
        };
      }
      const url = new URL(path, "https://local.invalid");
      const response = url.searchParams.get("id");
      const map = {
        "/cardapio": screen === "loja" ? "loja" : "cardapio",
        "/salas": "salas",
        "/bloqueios": "bloqueios",
        "/agendamentos": "agendar",
        "/batalhas": "desafios",
      };
      const resource = map[url.pathname];
      const allowed =
        {
          cardapio: ["cardapio"],
          loja: ["loja"],
          agendar: ["salas", "bloqueios", "agendar"],
          desafios: ["desafios"],
        }[screen] || [];
      if (
        url.pathname === "/agendamentos/lote" &&
        screen === "agendar" &&
        method === "put"
      ) {
        if (!Array.isArray(payload?.items) || payload.items.length > 1000)
          throw Error("Lista de agendamentos inválida.");
        const results = [];
        for (const row of payload.items) {
          if (row.status !== "cancelado")
            throw Error("Operação de agendamento inválida.");
          results.push(
            await request("agendar", {}, "POST", {
              action: "status",
              item_id: row.id,
              status: "cancelado",
            }),
          );
        }
        return {
          data: {
            status: "success",
            data: results.map(normalize),
          },
        };
      }
      if (
        !resource ||
        !allowed.includes(resource) ||
        !["post", "put", "delete"].includes(method)
      )
        throw Error("Esta operação não está disponível nesta tela.");
      let body = {
        ...(payload || {}),
        item_id: response || 0,
      };
      if (method === "delete")
        body = ["cardapio", "loja", "salas", "bloqueios"].includes(resource)
          ? {
              action: "status",
              item_id: response,
              active: 0,
            }
          : {
              action: "status",
              item_id: response,
              status: "cancelada",
            };
      else if (resource === "desafios")
        body = ["finalizada", "empate"].includes(payload?.status)
          ? {
              action: "finalize",
              item_id: response,
            }
          : {
              action: "status",
              item_id: response,
              status: payload?.status,
            };
      else if (resource === "agendar")
        body = {
          action: response ? "status" : "create",
          item_id: response || 0,
          ...(response
            ? {
                status: payload?.status,
              }
            : payload),
        };
      else {
        body.action = "save";
        if (resource === "loja") {
          body.imagem = body.foto;
          body.estoque = body.estoque ?? 0;
          delete body.preco;
          delete body.categoria;
        }
        for (const key of ["preco", "custo_token"])
          if (body[key] !== null && body[key] !== undefined)
            body[key] = String(body[key]);
        if (body.ativo !== undefined) body.ativo = body.ativo ? 1 : 0;
        const photo = resource === "loja" ? body.imagem : body.foto;
        if (
          (photo === null ||
            (typeof photo === "string" && photo.startsWith("data:image/"))) &&
          photo !== (storedPhotos.get(resource + ":" + response) ?? null)
        )
          body.photo = photo;
      }
      const saved = normalize(await request(resource, {}, "POST", body));
      if (["cardapio", "loja"].includes(resource))
        storedPhotos.set(
          resource + ":" + saved.id,
          resource === "loja" ? saved.imagem : saved.foto,
        );
      if (resource === "loja") {
        saved.foto = saved.imagem;
        saved.categoria = "salgado";
        saved.preco = null;
      }
      return {
        data: {
          status: "success",
          data: saved,
        },
      };
    }
    const context = Object.freeze({
      request,
      http: {
        get: (value, index) => nativeRequest("get", value, index),
        post: (value, index) => nativeRequest("post", value, index),
        put: (value, index) => nativeRequest("put", value, index),
        delete: (value) => nativeRequest("delete", value),
      },
    });
    const view = ReactDOM.createRoot(element);
    view.render(
      <InstitutionNativePage
        screen={screen}
        context={context}
        notify={options.notify || (() => {})}
        onStudent={options.onStudent}
      />,
    );
    return () => {
      abort.abort();
      view.unmount();
    };
  },
});
export {
  InstitutionLibraryView,
  InstitutionStudentsPage,
  InstitutionNativePage,
};
